// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"delete-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5 5H19L18.5 22H5.5L5 5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 5H19M5 5L5.5 22H18.5L19 5M5 5H3M19 5H21M8.5 2H15.5V5H8.5V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14.8287 10.6716L12.0003 13.5001M12.0003 13.5001L9.17188 16.3285M12.0003 13.5001L9.17188 10.6716M12.0003 13.5001L14.8287 16.3285","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Delete1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'delete-1',
    ref,
    icon: element,
  },
));

Delete1Icon.displayName = 'Delete1Icon';

export default Delete1Icon;
